import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { VariableVisitor } from './VariableVisitor';
import { putVisitor } from '../../store/Actions/ActionVisitor';
import '../../assets/styles/StylePopup.css'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang';
import { Form } from '../../components/general/general-component/abstruct-component/AbstructForm';

function EditVisitor({ arr, open, setOpen }) {
    const { mode, dispatch,langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    const { state, setStateCustom, setLoad, setState } = VariableVisitor();

    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            first_name: arr.first_name,
            last_name: arr.last_name,
            phone_number: arr.phone_number,
            email: arr.email,
        }));
    }, [arr]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(putVisitor(arr.id, state.first_name, state.last_name, state.phone_number, state.email, state.password, setLoad));
    };

    // Define the form fields, labels, and icon types
    const formFields = [
        { name: 'first_name', label: 'first_name', type: 'text', iconType: 'user' , inputType : 'text' },
        { name: 'last_name', label: 'last_name', type: 'text', iconType: 'user' , inputType : 'text' },
        { name: 'email', label: 'email', type: 'email', iconType: 'envelope' , inputType : 'text' },
        { name: 'phone_number', label: 'phone_number', type: 'text', iconType: 'phone' , inputType : 'text' },
        { name: 'password', label: 'password', type: 'password', iconType: 'key' , inputType : 'text' },
    ];

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: 'popupR',
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
                <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
                    <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('edit_visitor')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} translate={translate} buttonLabel="edit" />
            </div>
        </RModal>
    );
}

export default EditVisitor;

